<template>
  <van-dialog
    class="learn-statistics"
    ref="dialog"
    :is-show-footer="false">
    <div class="title" slot="title">学习统计</div>
    <div class="content">
      <transition-group name="fadeIn" mode="out-in">
        <!--<div
          v-show="currentMode.name === 'bar-chart'"
          key="bar-chart"
          class="chart"
          ref="chartBar">
        </div>-->
        <div
          key="area-chart"
          class="chart"
          ref="chartArea">
        </div>
      </transition-group>
      <!--<div class="controls">
        <i
          v-for="(mode, index) in modeList" :key="index"
          :data-title="mode.title"
          @click="toggleChart(index)"
          :class="`icon-${mode.name}`"
          class="icon iconfont">
        </i>
      </div>-->
    </div>
  </van-dialog>
</template>

<script>
import VanDialog from '@/components/common/Dialog.vue';
import api from '@/api/graphql/learning';

// 引入基本模板
const echarts = require('echarts/lib/echarts');

// 引入折线图等组件
require('echarts/lib/chart/line');
require('echarts/lib/chart/bar');

// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/lib/component/legend');
require('echarts/lib/component/toolbox');

const wordCountOption = {
  toolbox: {
    right: '50',
    itemSize: 18,
    feature: {
      magicType: {
        show: true,
        type: ['line', 'bar'],
      },
      saveAsImage: {
        show: true,
      },
    },
  },
  title: {
    text: '【最近一周内错题数量统计】',
    left: 'center',
  },
  legend: {
    data: ['错题数量'],
    left: 'left',
  },
  xAxis: {
    boundaryGap: true,
  },
  yAxis: [
    {
      type: 'value',
    },
  ],
  color: ['#409EFF'],
  series: [
    {
      name: '错题数量',
      type: 'bar',
      data: [],
      barWidth: 28,
      label: {
        show: true,
        position: 'top',
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold',
          color: '#409EFF',
        },
      },
    },
  ],
};

const examScoreOption = {
  toolbox: {
    right: '50',
    itemSize: 18,
    feature: {
      magicType: {
        show: true,
        type: ['line', 'bar'],
      },
      saveAsImage: {
        show: true,
      },
    },
  },
  title: {
    text: '【最近7次考试成绩】',
    left: 'center',
  },
  tooltip: {
    trigger: 'axis',
    formatter(params) {
      return params[0].data.name;
    },
  },
  legend: {
    data: ['分数'],
    left: 'left',
  },
  xAxis: [],
  yAxis: [
    {
      type: 'value',
    },
  ],
  color: ['#409EFF'],
  series: [
    {
      name: '分数',
      type: 'bar',
      data: [],
      barWidth: 28,
      label: {
        show: true,
        position: 'top',
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold',
          color: '#409EFF',
        },
      },
    },
  ],
};

export default {
  components: {
    VanDialog,
  },
  props: {
    bookId: {
      type: Number,
      isRequired: true,
    },
  },
  data() {
    return {
      modeList: [
        // {
        //   name: 'bar-chart',
        //   type: 'Bar',
        //   title: '最近一周内错题数量',
        // },
        {
          name: 'area-chart',
          type: 'Area',
          title: '最近7次考试成绩',
        },
      ],
      currentModeIndex: 0,
    };
  },
  computed: {
    currentMode() {
      return this.modeList[this.currentModeIndex];
    },
    courseId() {
      return Number(this.$route.params.courseId) || 0;
    },
  },
  methods: {
    open() {
      this.$refs.dialog.open();
      this.$nextTick(() => {
        this.drawChart();
      });
    },
    close() {
      this.$emit('end');
    },
    toggleChart(index) {
      this.currentModeIndex = index;
    },
    drawChart() {
      // this.drawWrongCount();
      this.drawLearningTime();
    },
    drawWrongCount() {
      const barChart = echarts.init(this.$refs.chartBar);
      api.getWrongRecords({
        courseId: this.bookId,
      }).then(({ lastDaysWrongRecords }) => {
        if (!lastDaysWrongRecords.length) {
          wordCountOption.title.text = '【最近一周内错题数量统计】\n\n\n\n\n\n\n\n\n\n暂无数据';
        } else {
          wordCountOption.title.text = '【最近一周内错题数量统计】';
        }
        const dates = lastDaysWrongRecords.map(item => item.label);
        const count = lastDaysWrongRecords.map(item => item.value);
        wordCountOption.xAxis.data = dates;
        wordCountOption.series[0].data = count;
        barChart.setOption(wordCountOption);
      });
    },
    drawLearningTime() {
      const barChart = echarts.init(this.$refs.chartArea);
      api.getExamScore({
        courseId: this.bookId,
      }).then(({ lastDaysExamRecords }) => {
        if (!lastDaysExamRecords.length) {
          examScoreOption.title.text = '【最近7次考试成绩】\n\n\n\n\n\n\n\n\n\n暂无数据';
        } else {
          examScoreOption.title.text = '【最近7次考试成绩】';
        }
        const dates = lastDaysExamRecords.map(item => item.updatedAt);
        const seconds = lastDaysExamRecords.map(item => ({
          value: item.score,
          name: item.name,
        }));

        examScoreOption.xAxis = {
          data: dates,
        };
        examScoreOption.series[0].data = seconds;
        barChart.setOption(examScoreOption);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

.learn-statistics {
  /deep/ .el-dialog {
    .el-dialog__body {
      .content {
        padding: 0;
      }
    }
  }
  .content {
    overflow: hidden;
    .chart {
      width: 818px;
      height: 420px;
      margin: 60px auto;
      .read-more {
        display: block;
        width: 100%;
        text-align: center;
        color: #00b29f;
        text-decoration: none;
        cursor: pointer;
      }
    }
    .controls {
      padding-bottom: 15px;
      padding-right: 45px;
      text-align: right;
      i {
        margin-right: 15px;
        font-size: 45px;
        color: $primary;
        position: relative;
        cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
          &:after {
            display: inline-block;
            padding: 2px 4px;
            font-size: 12px;
            border: 1px solid #4d4d4d;
            color: #4d4d4d;
            white-space:nowrap;
            content: attr(data-title);
            position: absolute;
            bottom: -15px;
            left: 0;
            opacity: 0;
            box-shadow: 1px 1px 2px rgb(112, 112, 112);
            transition: all .5s .3s;
          }
          &:hover:after {
            opacity: 1;
          }
      }
      .icon-bar-chart {
        position: relative;
      }
    }
  }
}
.download-dialog {
  font-size: 16px;
  .el-dialog {
    width: 700px!important;
  }
  .title {
    text-align: center;
  }
  .content {
    .checkbox-type {
      margin-top: 40px;
    }
    .checkbox {
      margin: 30px 0 0 15px;
    }
  }
  .footer {
    text-align: right;
  }
  .el-checkbox__label {
    font-size: 16px;
  }
}
.fadeIn-enter-active{
  transition: opacity .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fadeIn-leave {
  display: none;
}
.fadeIn-enter{
  opacity: 0;
}
</style>
